export default "__VITE_ASSET__BT7VG_Yy__"